<template>
	<div class="topUps">
		<div class="topUps_head">
			<span class="ups_left">充值</span>
			<span class="ups_right" @click="close('cz')">关闭</span>
		</div>
		<div  class="upsBox">
			<div class="dianchi">
				<ul>
					<li @click="go('cz')">
						<i class="el-icon-s-finance"></i>
						<span>可用电池：{{topUps}}</span>
						<p>充值</p>
					</li>
					<li @click="go('yemx')">
						<i class="el-icon-s-order"></i>
						<span></span>
						<p>余额明细</p>
					</li>
					<li @click="go('czmx')">
						<i class="el-icon-s-data"></i>
						<span></span>
						<p>充值明细</p>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import qs from "qs"	
export default {	
	props:['chongzhi','goto'],
  data () {
    return {
    	qunData:[],
		memberData:[],
		topUps:'***'
		 
    }
  },
  computed:{
  	getQunData:function(){
  		return this.qunData
  	},
  	getMemberData:function(){
  		return this.memberData
  	},
  },
  methods:{
  	close(data){
  		 if (this.chongzhi) {
          this.chongzhi(data);
        }
  	},
  	go(data){
  		
  		if (this.goto) {
          this.goto(data)
        }
  	},
  	getInfo(){		
		this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
		this.$axios.post('/goods/account/v1/balance')
		.then(userData=>{
			if(userData.data.resultCode=='0000'){
				this.topUps=userData.data.resultInfo.avabal
				
			}else{
				this.$message.error(userData.data.resultMsg);
			}	
		}).catch(error=>{
			console.log(error)
		})  		
  	},
	getCookie(c_name){
	//判断document.cookie对象里面是否存有cookie
	if (document.cookie.length>0){
	  var c_start=document.cookie.indexOf(c_name + "=")
		//如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
	  if (c_start!=-1){ 
	    c_start=c_start + c_name.length+1 
	   var c_end=document.cookie.indexOf(";",c_start)
	    if (c_end==-1) c_end=document.cookie.length
	     return unescape(unescape(document.cookie.substring(c_start,c_end)))
	    } 
	  }
	return ""
	},		  
  },
  created:function(){
  		this.getInfo()
  },
}	
</script>

<style scoped>
.topUps{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: #FFFFFF;
	z-index: 1000;
	overflow: auto;
	padding-top: 40px;
}
.topUps_head{
	background: #F2F6FC;
	position: absolute;
	width: 100%;
	left: 0;
	top: 0;
	line-height: 40px;
	padding: 0px 15px;
	overflow: hidden;
}
.ups_left{
	float: left;
	font-weight: bold;
}
.ups_right{
	float: right;
	color: red;
	cursor: pointer;
}
.upsBox{
	width: 100%;
	height: 100%;
	overflow: auto;
}
.dianchi{
	
}
.dianchi ul{
	overflow: hidden;
	padding-top: 15px;
}
.dianchi ul li{
	text-align: center;
	float: left;
	width: 33.33333%;
	padding: 15px 0px;
	cursor: pointer;
}
.dianchi ul li:hover{
	background: #F2F6FC;
}
.dianchi ul li i{
	display: block;
	margin: auto;
	font-size: 60px;
	color: #666666;
}
.dianchi ul li span{
	display: block;
	margin: auto;
	color: #666666;
	height: 20px;
	line-height: 20px;
	font-size: 12px;
}

.dianchi ul li p{
	display: block;
	margin: auto;
	color: red;
}

</style>


// WEBPACK FOOTER //
// src/components/im/topUps.vue